import React, {Component} from 'react';
import {Redirect} from "react-router-dom";
import {getOrgs} from '../services/orgService';
import ErrorAlert from "../components/ErrorAlert";
import Members from "../components/organisation/Members"
import Assignees from "../components/organisation/Assignees"
import Folders from "../components/organisation/Folders"
import JiraConfig from "../components/organisation/JiraConfig"
import Banner from "../patterns/Banner";
import {Helmet} from "react-helmet";
import styles from './Organisation.module.css';

export default class Organisation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            org: null,
            persistentErrorMessage: null,
            disabled: false,
            // No workflow to actually change an org's owner exists yet - kept
            // as a permanently-disabled placeholder, same as before the redesign.
            changeOwnerDisabled: true,
        }
    }

    async componentDidMount() {
        if (!this.props.authentication) {
            console.warn('Not logged in, redirecting')
            this.setState({redirectUrl: '/'});
            return;
        }
        try {
            const {orgId} = this.props.match.params;
            const orgs = await getOrgs(orgId);
            const org = orgs.find(o => o.id === orgId);
            if (org) {
                this.setState({org, disabled: org.status !== 'PAID'})
            } else {
                throw new Error(`Unable to find org ${orgId}`)
            }
        } catch (error) {
            this.setState({
                persistentErrorMessage: `Problem getting org: ${error.toString()}`
            });
        }
    }

    isOrgOwner = () => {
        return this.props.authentication.sub === this.state.org.ownerId
    }

    render() {
        if (this.state.redirectUrl) {
            return <Redirect to={this.state.redirectUrl}/>
        }

        const {org, persistentErrorMessage, disabled} = this.state;

        return (
            <div className={styles.root}>
                <Helmet>
                    <title>Ovalview | Organisation</title>
                </Helmet>
                <div className={styles.page}>
                    {!org && !persistentErrorMessage && <p className={styles.loading}>Loading org…</p>}
                    <ErrorAlert message={persistentErrorMessage} delay={0}/>

                    {org && (
                        <div>
                            {disabled && (
                                <Banner tone="warning">
                                    Org functionality is disabled until your subscription is{' '}
                                    <a href="/banding">activated</a>
                                </Banner>
                            )}
                            {org.endDate && (
                                <Banner tone="info">Your org has a free trial enabled</Banner>
                            )}

                            <div className={styles.header}>
                                <div>
                                    <p className={styles.eyebrow}>Organisation</p>
                                    <h1 className={styles.title}>{org.name}</h1>
                                </div>
                                <button type="button" className={styles.changeOwnerButton}
                                        disabled={this.state.changeOwnerDisabled}>
                                    Change Owner
                                </button>
                            </div>

                            <div className={styles.columns}>
                                <Members org={org} disabled={disabled || !this.isOrgOwner()} isOwner={this.isOrgOwner()}/>
                                <div>
                                    <Folders org={org} disabled={disabled}/>
                                    <JiraConfig org={org} disabled={disabled || !this.isOrgOwner()} isOwner={this.isOrgOwner()}/>
                                    <Assignees org={org} disabled={disabled || !this.isOrgOwner()} isOwner={this.isOrgOwner()}/>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
